import { ReactNode } from 'react';

type InlineStyles = {
    [key: string]: unknown
}

type ReportContentWrapperProps = {
    children?: ReactNode;
    inlineStyles?: InlineStyles
}

const DEFAULT_INLINE_STYLES: InlineStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: '55px',
    marginRight: '55px'
};

export const ReportContentWrapper = ({
    children,
    inlineStyles
}: ReportContentWrapperProps) => {
    const appliedInlineStyles = inlineStyles ?
        {
            ...DEFAULT_INLINE_STYLES,
            ...inlineStyles
        } : DEFAULT_INLINE_STYLES;
    return (
        <div
            style={appliedInlineStyles}
        >
            {children}
        </div>
    );
};
